"use client";

import type { ReactNode } from "react";
import { usePlatformSettings } from "@/lib/settings/context";

export function LeaderboardOnly({ children }: { children: ReactNode }) {
  const { isLeaderboardEnabled } = usePlatformSettings();
  if (!isLeaderboardEnabled) return null;
  return <>{children}</>;
}
